import React from 'react';
import { FormGroup, FormControl, Form, Table, Row, Col, ControlLabel } from 'react-bootstrap';
import Select from 'react-select';

class ProyectosSubTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: null,
      error: {},
      convocatoriaFiltro: {value: this.props.convocatorias[0], label: this.props.convocatorias[0]},
    };
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.generateRows = this.generateRows.bind(this);
    this.onChangeConvocatoriaFilter = this.onChangeConvocatoriaFilter.bind(this);
    this.getData = this.getData.bind(this);
    this.generateConvocatoriaOptions = this.generateConvocatoriaOptions.bind(this);
  }

  componentWillMount() {
    this.getData(this.props.convocatorias[0]);
  }

  getData(convocatoria) {
    this.props.incubationService
      .getPreselectedProjects(convocatoria)
      .then(res => {
        this.setState({ projects: res.proyectos });
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  onChangeConvocatoriaFilter(item) {
    this.setState({convocatoriaFiltro: item});
    if (item && item !== '') {
      this.getData(item.value);
    } else {
      this.getData();
    }
  }

  generateConvocatoriaOptions() {
    return this.props.convocatorias.map((item) => {
      return {value: item, label: item};
    });
  }

  handleOnBlur(value, id) {
    const auxStateError = this.state.error;
    if (value > 10 || value < 0) {
      auxStateError[id] = true;
      this.setState({ error: auxStateError });
    } else {
      auxStateError[id] = false;
      this.setState({ error: auxStateError });
      this.props.incubationService
        .calificateProject(id, value)
        .then(res => {
          //do nothing
        })
        .catch(err => {
          this.props.setError((<div>Ha ocurrido un error mientras guardaba la puntuación, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });
    }
  }

  generateRows() {
    const html = [];
    this.state.projects.forEach((project) => {
      html.push(
        <tr key={project.id}>
          <td>{project.nombre}</td>
          <td style={{width: '200px'}}>
            <FormGroup validationState={this.state.error[project.id] ? 'error': null}>
              <FormControl
                bsSize="small"
                type="number"
                defaultValue={!project.calificacion ? '' : project.calificacion}
                onBlur={(e) => this.handleOnBlur(e.target.value, project.id)}
              />
            </FormGroup>
          </td>
        </tr>
      );
    });
    return html;
  }

  render() {
    if (!this.state.projects) {
      return(<div></div>);
    }
    return(
      <div style={{maxHeight: '600px', overflowY: 'auto', overflowX: 'hidden'}}>
        <Form horizontal>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                  Convocatoria:
                </Col>
                <Col md={6}>
                  <Select
                    placeholder="Seleccione"
                    closeOnSelect={true}
                    name="type"
                    value={this.state.convocatoriaFiltro}
                    options={this.generateConvocatoriaOptions()}
                    onChange={(value) => this.onChangeConvocatoriaFilter(value)}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </Form>
        {this.state.projects.length === 0 ?
          <div>No hay projectos preseleccionados</div> :
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th className="success">Proyecto</th>
                <th>Calificacion</th>
              </tr>
            </thead>
            <tbody>
              {this.generateRows()}
            </tbody>
          </Table>
        }
      </div>
    );
  }
}

export default ProyectosSubTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreSelectionComponents/ProyectosSubTab.jsx